export function InputText({
  label,
  name,
  type,
  autocomplete,
}: {
  label?: string;
  name: string;
  type: string;
}) {
  return (
    <div>
      {label && (
        <label
          htmlFor="last-name"
          className="block text-sm/6 font-semibold text-slate-900"
        >
          {label}
        </label>
      )}
      <div className="mt-1">
        <input
          name={name}
          type={type || "text"}
          autoComplete={autocomplete}
          className="block w-full rounded-md bg-white px-3.5 py-2 text-base text-slate-900 outline outline-1 -outline-offset-1 outline-slate-300 placeholder:text-slate-400 focus:outline focus:outline-1 focus:-outline-offset-1 focus:outline-default-600"
        />
      </div>
    </div>
  );
}
